__turbopack_context__.v({
  "btn__next": "SwiperComponent-module-scss-module__a3mZ7W__btn__next",
  "btn__prev": "SwiperComponent-module-scss-module__a3mZ7W__btn__prev",
  "disabled": "SwiperComponent-module-scss-module__a3mZ7W__disabled",
  "navigation": "SwiperComponent-module-scss-module__a3mZ7W__navigation",
});
